import animatedScrollTo from 'animated-scroll-to'

const filters = document.querySelector('.entry-grid__filter')

const scrollToFilters = () => {
    const getStickyHeaderHeight = () =>
        (window.innerWidth > 860
            ? 60
            : (document.querySelector('#global-header .nav__top') || {})
                .clientHeight || 0)
        + ((document.querySelector('#global-header .nav__dropdown.active')
            || {}).clientHeight || 0)

    const queryParams = window.location.search
        .replace(/^\?/, '')
        .split('&')
        .map(str => decodeURIComponent(str.trim())
            .split('='))
        .filter(arr => arr.length > 1)
        .reduce((obj, [key, value]) => {
            if (!obj[key])
                return { ...obj, [key]: value }

            if (Array.isArray(obj[key]))
                obj[key].push(value)

            if (!Array.isArray(obj[key]))
                obj[key] = [obj[key], value]

            return obj
        }, {}) || {}

    const filterActiveAnchor = filters.querySelector('a[aria-current]')

    const paginationActiveAnchor
        = document.querySelector('.pager__block[aria-current=page]')

    const isScrollTo = (queryParams.filter
            && filterActiveAnchor.href
                .split('?filter=')[1]
                    === queryParams.filter)
        || (paginationActiveAnchor
            && paginationActiveAnchor.innerText !== '1')

    if ((queryParams.filter === 'all'
                || (queryParams.filter
                    && !filterActiveAnchor))
            && window.history)
        window.history.replaceState(null, null,
            window.location.href.replace(window.location.search, ''))

    const scrollToOpts = {
        cancelOnUserAction: false,
        easing: t => t < 0.5
            ? 4 * t * t * t
            : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
        speed: 200
    }

    const scrollFilterTrackToActive = () => {
        if (!filterActiveAnchor)
            return

        const navScrollTrack = filterActiveAnchor.parentElement.parentElement

        const filterActiveAnchorX2 = filterActiveAnchor.offsetLeft
            + filterActiveAnchor.clientWidth

        const isNavScrollX = filterActiveAnchorX2 > navScrollTrack.clientWidth

        return !isNavScrollX
            ? Promise.resolve()
            : animatedScrollTo([filterActiveAnchorX2, 0],
                Object.assign(scrollToOpts, {
                    elementToScroll: navScrollTrack
                }))
    }

    if (!isScrollTo || window.pageYOffset)
        return scrollFilterTrackToActive()

    const isSafari = window.navigator.userAgent.indexOf('Safari') >= 0
        && window.navigator.userAgent.indexOf('Chrome') === -1

    const focusEl = (el) => {
        if (!el)
            return

        if (el.tabIndex === -1
                && !el.getAttribute('tabindex'))
            el.setAttribute('tabindex', -1)

        el.style.outline = 'none'
        el.focus({ preventScroll: true })

        setTimeout(() => {
            el.classList.remove('focus-visible')
            el.style.outline = ''
        }, 1)
    }

    if (isSafari)
        focusEl(filterActiveAnchor)

    animatedScrollTo(
        filters.offsetTop - getStickyHeaderHeight(),
        scrollToOpts
    ).then((done) => {
        if (done
                && !isSafari)
            focusEl(filterActiveAnchor)

        scrollFilterTrackToActive()

        return done
    })
}

if (filters)
    window.addEventListener('load', () => scrollToFilters())
